import "./Review.css";
import { FaArrowRight } from 'react-icons/fa';
import { useState, useEffect, useRef } from "react";
import left from "../../Photos/Icons/arrowIconThink.png";
import { FaA } from "react-icons/fa6";
const Review = ({ReviewC}) => {
  const img = "https://imgs.search.brave.com/y37tRYaAaKgLNGG4Uh_AEvh6pqmTqGziDci9xYe2Qew/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly93d3cu/dGhlZmlsbW5lcGFs/LmNvbS91cGxvYWRz/L21lZGlhcy9iYWxl/bi1zaGFoLmpwZw";
  const img2 = "https://scontent.fktm9-2.fna.fbcdn.net/v/t39.30808-6/448267865_773272055006287_4312168140936838199_n.jpg?_nc_cat=103&ccb=1-7&_nc_sid=6ee11a&_nc_ohc=9S-XmuZH6c8Q7kNvwHw3Yfp&_nc_oc=Adm4sseM5i5yRJKCbLtVKa_kfvg_rihx7ly-kDiTrLJOho-WbnPC76ufcdFCnYc6oaA&_nc_zt=23&_nc_ht=scontent.fktm9-2.fna&_nc_gid=UNsbdOcKGzSk2mXOeDRX5w&oh=00_Afd0V74Re2eNA2G6OHKJ2QKCW077NKb0rJBjVAfQvdpIfw&oe=68EA7CFE";

  const reviews = ReviewC
  const reviewsS = [
    {
      quote: "Scaleup Academy in Pokhara provides hands-on courses and mentorship to help turn creative passions into professional careers.",
      name: "Rabin Poudel",
      title: "Senior Video Editor",
      image: "https://lh3.googleusercontent.com/a-/ALV-UjUHU-WiY32OMV9nVkUhrgEQSRnEOT2mH-Q2kOAlT9dPOoGm2FSR=w90-h90-p-rp-mo-br100"
    },
    {
      quote: "Untitled transformed how we manage projects—faster, smarter, and more collaborative than ever.",
      name: "Anish bhandari",
      title: "Student",
      image: "https://lh3.googleusercontent.com/a/ACg8ocIb0qXVVpZdzqThy7KJdsuXCRRqp_3MjRoLD98XvI-cgINK1gbr=w90-h90-p-rp-mo-br100"
    },
    
  ];


  const [activeIndex, setActiveIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const containerRef = useRef(null);
  const itemRefs = useRef([]);

  // Auto-update activeIndex every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setActiveIndex((prevIndex) => {
        let nextIndex = prevIndex + direction;

        if (nextIndex >= reviews.length) {
          setDirection(-1);
          nextIndex = prevIndex - 1;
        } else if (nextIndex < 0) {
          setDirection(1);
          nextIndex = prevIndex + 1;
        }

        return nextIndex;
      });
    }, 3000);

    return () => clearInterval(interval);
  }, [direction, reviews.length]);

  // Center the active review
  useEffect(() => {
    const container = containerRef.current;
    const activeItem = itemRefs.current[activeIndex];

    if (container && activeItem) {
      const containerWidth = container.offsetWidth;
      const itemOffsetLeft = activeItem.offsetLeft;
      const itemWidth = activeItem.offsetWidth;

      const scrollTo = itemOffsetLeft - containerWidth / 2 + itemWidth / 2;
      container.scrollTo({ left: scrollTo, behavior: "smooth" });
    }
  }, [activeIndex]);

  function minusIndex() {
    if (activeIndex === 0) {

    }
    else {
      const ind = activeIndex - 1;
      setActiveIndex(ind);
    }
  }

  function plusIndex() {
    if (activeIndex === reviews.length - 1) {

    }
    else {
      const ind = activeIndex + 1;
      setActiveIndex(ind);
    }
  }

  // For Image Index
  const getZIndex = (index, activeIndex) => {
    const distance = Math.abs(index - activeIndex);
    const maxZ = 5; // highest z-index at center
    return Math.max(maxZ - distance, 0); // ensures z-index never goes negative
  };

  return (
    <>
      <div className="reviewPage">
        <div className="reviewTitle">
          <p>What<br /> They Say About Us</p>
          <p>Real words. Real experiences. Real impact.</p>
        </div>

        {/* <div className="studentsImages">
          <div className="listImage">
              <img style={{ zIndex: 1}} className=""  src={activeIndex <0 ? "": reviews[activeIndex-2].image} alt="std" />
              <img style={{ zIndex: 2}} className=""  src={activeIndex <1 ? "": reviews[activeIndex-1].image} alt="std" />
              <img style={{ zIndex: 3}} className="active"  src={reviews[activeIndex].image} alt="std" />
              <img style={{ zIndex: 2}} className=""  src={reviews[1].image} alt="std" />
              <img style={{ zIndex: 1}} className=""  src={reviews[1].image} alt="std" />
          </div>
        </div> */}

        <div className="studentsImages">
          <div className="listImage">
            {[-2, -1, 0, 1, 2].map((offset, i) => {
              const index = activeIndex + offset;

              // Wrap around if index is out of range
              const validIndex = (index + reviews.length) % reviews.length;
              const review = reviews[validIndex];

              return (
                <img
                  key={i}
                  src={review.image}
                  alt={review.name}
                  className={`student-img ${offset === 0 ? "active" : ""}`}
                  style={{
                    zIndex: 5 - Math.abs(offset),
                    transform: offset === 0 ? "scale(1.2)" : `scale(${1 - Math.abs(offset) * 0.1})`,
                    opacity: offset === 0 ? 1 : 0.6,
                    transition: "all 0.4s ease",
                  }}
                />
              );
            })}
          </div>
        </div>


        <div data-aos="zoom-in" ref={containerRef} className="listReviews">
          <div className="reviewBox" >
            <div className="review1">

            </div>
            <div className="review2">
            </div>

            {reviews.map((rev, index) =>
              <div  className={`review ${index === activeIndex ? "active" : "notactive"}`}
                ref={(el) => (itemRefs.current[index] = el)}
                key={index} >
                <p className="quote">
                  {rev.desc}
                </p>
                <div className="profile">
                  <img src={rev.image} alt={rev.name} className="avatar" />
                  <div className="info">
                    <p className="name">{rev.name} </p>
                    <p className="title">{rev.title} </p>
                  </div>
                </div>
              </div>
            )}
            <div className="review2">

            </div>
            <div className="review1">

            </div>

          </div>
        </div>

        <div className="changeIndex">
          {/* <FaArrowRight onClick={() => minusIndex()} className="left" /> */}
            <img onClick={() => minusIndex()} src={left} className="right" />
            <img onClick={() => plusIndex()} src={left} className="left" />
          {/* <FaArrowRight onClick={() => plusIndex()} className="right" /> */}
        </div>
      </div>
    </>
  )
}
export default Review;